<div class="rad-overlay" (click)="onClose()">
  <div class="rad-card" role="dialog" aria-modal="true" aria-labelledby="rad-title"
    (click)="$event.stopPropagation()">

    @if (sent()) {
      <div class="rad-sent">
        <span class="rad-sent__check"><i class="pi pi-check"></i></span>
        <h3 class="rad-sent__title">Request sent</h3>
        <p class="rad-sent__sub">
          The team reviews every request — your use case and timing go straight to
          the connector roadmap.
        </p>
        <button type="button" class="rad-btn rad-btn--primary" (click)="onClose()">Done</button>
      </div>
    } @else {
      <div class="rad-head">
        <span class="rad-head__icon"><i class="pi pi-lightbulb"></i></span>
        <h3 class="rad-head__title" id="rad-title">Request an ability</h3>
        <button type="button" class="rad-icon-btn" (click)="onClose()" [disabled]="submitting()" aria-label="Close">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="rad-body">
        <div class="rad-field">
          <label class="rad-label" for="rad-what">What do you need?</label>
          <input id="rad-what" class="rad-input" [ngModel]="what()" maxlength="200"
            placeholder="e.g. Power BI, ServiceNow, SharePoint…"
            (ngModelChange)="what.set($event)" />
        </div>

        <div class="rad-field">
          <label class="rad-label" for="rad-usecase">
            What would you build with it? <span class="rad-req">*</span>
          </label>
          <textarea id="rad-usecase" class="rad-textarea" rows="4" maxlength="2000"
            [ngModel]="useCase()" (ngModelChange)="useCase.set($event)"
            placeholder="The agent you have in mind, who it's for, and what data it needs — this is what the team prioritizes on."></textarea>
        </div>

        <div class="rad-field">
          <span class="rad-label" id="rad-when-label">When do you need it?</span>
          <div class="rad-chips" role="group" aria-labelledby="rad-when-label">
            @for (t of timeframes; track t.id) {
              <button type="button" class="rad-chip" [class.rad-chip--active]="timeframe() === t.id"
                (click)="timeframe.set(t.id)">{{ t.label }}</button>
            }
          </div>
        </div>

        <div class="rad-info">
          <i class="pi pi-info-circle"></i>
          <span>Sent to the platform team with your name, recorded on the ability roadmap,
            and reviewed against other requests.</span>
        </div>

        @if (error()) {
          <div class="rad-error" role="alert">{{ error() }}</div>
        }
      </div>

      <div class="rad-foot">
        <button type="button" class="rad-btn rad-btn--ghost" (click)="onClose()" [disabled]="submitting()">Cancel</button>
        <button type="button" class="rad-btn rad-btn--primary" (click)="submit()" [disabled]="!canSubmit()">
          {{ submitting() ? 'Sending…' : 'Send request' }}
        </button>
      </div>
    }
  </div>
</div>
